import {
  GENERATE_AGENT_DESIGN_REQUEST,
  GENERATE_AGENT_DESIGN_SUCCESS,
  GENERATE_AGENT_DESIGN_FAILURE,
  GET_AGENT_DESIGN_LIST_REQUEST,
  GET_AGENT_DESIGN_LIST_SUCCESS,
  GET_AGENT_DESIGN_LIST_FAILURE,
  CLEAR_AGENT_DESIGN,
  SET_AGENT_DESIGN_SPECIFICATION,
} from "actions/agent/agentDesign";
import { SEGMENT_BY } from "constants/agentDesign";
import { uSimError } from "utils/override";

const getDefaults = () => {
  let data = {};
  SEGMENT_BY.forEach((it) => {
    data = {
      ...data,
      [it.value]: it.defaultSelected,
    };
  });

  return data;
};

const initialState = {
  loading: false,
  list: [],
  generateLoading: false,
  isGenerated: true,
  specification: {
    segments: getDefaults(),
    confidence_interval: "90/10",
  },
};

const processList = (list) => {
  return list.map((it, i) => {
    let className = "";
    let isCustomersError = false;
    let isVarianceError = false;

    const poolSamples =
      parseInt(it.POOL_Samples_Available.replace(/,/g, ""), 10) || 0;
    const popSamples = it.POP_Sample_Size || 0;

    const customers =
      poolSamples > 0
        ? parseFloat(((popSamples / poolSamples) * 100).toFixed(2))
        : 0;
    const variance = it?.Variance ? parseFloat(it.Variance.toFixed(2)) : 0;

    const highlightKey = customers > variance ? "customers" : "variance";
    const highlightValue = customers > variance ? customers : variance;

    if (highlightKey === "customers") {
      if (highlightValue <= 100) {
        className = "highlight-green";
      } else if (highlightValue <= 110) {
        className = "highlight-orange";
        isCustomersError = true;
      } else {
        className = "highlight-red";
        isCustomersError = true;
      }
    } else if (highlightKey === "variance") {
      if (highlightValue <= 10) {
        className = "highlight-green";
      } else if (highlightValue <= 20) {
        className = "highlight-orange";
        isVarianceError = true;
      } else {
        className = "highlight-red";
        isVarianceError = true;
      }
    }

    return {
      ...it,
      id: i,
      customers,
      variance,
      className,
      isCustomersError,
      isVarianceError,
    };
  });
};

export default function agentDesign(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GENERATE_AGENT_DESIGN_REQUEST: {
      return {
        ...state,
        generateLoading: true,
      };
    }

    case GENERATE_AGENT_DESIGN_SUCCESS: {
      return {
        ...state,
        generateLoading: false,
        list: processList(payload),
      };
    }

    case GENERATE_AGENT_DESIGN_FAILURE: {
      uSimError(payload?.message || "Something went wrong");
      return {
        ...state,
        generateLoading: false,
      };
    }

    case GET_AGENT_DESIGN_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_AGENT_DESIGN_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        isGenerated: payload.length > 0,
        list: processList(payload),
      };
    }

    case GET_AGENT_DESIGN_LIST_FAILURE: {
      uSimError(payload?.message || "Something went wrong");
      return {
        ...state,
        loading: false,
        isGenerated: false,
      };
    }

    case CLEAR_AGENT_DESIGN: {
      return {
        ...state,
        ...initialState,
      };
    }

    case SET_AGENT_DESIGN_SPECIFICATION: {
      return {
        ...state,
        specification: payload,
      };
    }

    default:
      return state;
  }
}
